import React from "react";
import { Box, Button, FormControl, FormLabel } from "@mui/material";
import { useDispatch } from "react-redux";
import { markPlaylistAsReviewed } from "../../../../store/Playlists/playlistsThunks";

function MarkAsReviewedForm({ playlistId, playlistName, onSubmit }) {
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const resultAction = await dispatch(markPlaylistAsReviewed(playlistId));
      if (markPlaylistAsReviewed.fulfilled.match(resultAction)) {
        if (onSubmit) onSubmit(resultAction.payload);
      } else {
        console.error(
          "Failed to mark playlist as reviewed:",
          resultAction.payload
        );
      }
    } catch (err) {
      console.error("Unexpected error:", err);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <FormControl fullWidth>
        <FormLabel>
          You are about to mark playlist {playlistName} as reviewed.
        </FormLabel>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
        >
          Mark Playlist as Reviewed
        </Button>
      </FormControl>
    </Box>
  );
}

export default MarkAsReviewedForm;
